<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="field-body tags-input">
      <span v-for="(tag, idx) in tags" class="tag is-medium" :key="idx">
        {{ tag }}
        <div class="tag-button">
          <button
            class="delete is-small"
            @click="remove(idx)"
            v-if="!disabled"
          />
        </div>
      </span>
      <div class="columns is-mobile is-gapless">
        <input
          class="input"
          :value="newTag"
          :placeholder="$t('Add')"
          @keyup.enter="add($event.target.value)"
          @input="onInput($event.target.value)"
          v-if="!disabled"
          list="dropdown"
          autocomplete="off"
        />
        <datalist id="dropdown">
          <option
            v-for="option in availableTags"
            :key="option"
            :value="option"
          />
        </datalist>
        <button
          class="button column is-3"
          @click="add(newTag)"
          :disabled="!canAdd(newTag)"
          v-if="newTag"
        >
          {{ $t("Add") }}
        </button>
      </div>
      <p class="help is-danger">{{ $t(errors && errors[0]) }}</p>
    </div>
  </div>
</template>

<script>
import { isString } from "@/utils"

// value = ["tag1", "tag2"]
export default {
  name: "tag-list",
  props: ["value", "options", "selectedValue", "label", "disabled", "errors"],
  data() {
    return {
      newTag: ""
    }
  },
  watch: {
    value() {
      this.newTag = ""
    }
  },
  computed: {
    tags() {
      // value ~ tags, because v-model convention
      return this.value
    },
    availableTags() {
      if (this.options) {
        return this.options.filter(tag => !this.tags.includes(tag))
      }
      return []
    }
  },
  methods: {
    remove(index) {
      const newTags = this.tags.filter((_, idx) => idx !== index)
      this.$emit("input", newTags)
    },
    add(tag) {
      if (this.canAdd(tag)) {
        this.newTag = ""
        this.$emit("input", [...this.tags, tag.trim()])
      }
    },
    onInput(value) {
      this.newTag = value
      const isInputFromDatalist = this.availableTags.includes(value)
      if (isInputFromDatalist && this.canAdd(value)) {
        this.add(value)
      }
    },
    canAdd(tag) {
      return isString(tag) && tag.trim().length > 0 && !this.tags.includes(tag)
    }
  }
}
</script>

<style lang="scss">
// TODO: optimize html & css
.tags-input {
  min-height: 2.25em;
  flex-direction: row;
  flex-wrap: wrap;
}
.tag {
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  .tag-button {
    margin-left: 4px;
    height: 16px;
  }
}
</style>
